import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  buildChatHandoffUrl,
  createChatHandoffPayload,
  storeChatHandoff,
} from '../../../utils/chatHandoff';
import NewsShareButton from './NewsShareButton';

const TARGET = 'worksheet_gen';

const NewsClassroomIdea = ({ idea, date }) => {
  const navigate = useNavigate();
  if (!idea?.title) return null;

  const handleMake = () => {
    const payload = createChatHandoffPayload({
      href: `/chat?category=${TARGET}`,
      sourceContent: idea.prompt || idea.title,
      sourceCategory: 'edu_news',
      sourcePurpose: 'eduNewsIdea',
    });
    const handoffId = payload && storeChatHandoff(payload);
    if (handoffId) {
      navigate(buildChatHandoffUrl(TARGET, handoffId));
    } else if (payload) {
      navigate('/chat', { state: { chatHandoff: payload } });
    } else {
      navigate(`/chat?category=${TARGET}`);
    }
  };

  return (
    <section id="idea" className="news-card news-idea" aria-labelledby="news-idea-title">
      <p className="news-eyebrow">오늘 수업에 바로 쓰는 아이디어</p>
      <h2 id="news-idea-title" className="news-idea-title">
        {idea.title}
        {idea.minutes ? <span className="news-idea-minutes">{idea.minutes}분</span> : null}
      </h2>
      {idea.steps?.length > 0 && (
        <ol className="news-idea-steps">
          {idea.steps.map((step) => <li key={step}>{step}</li>)}
        </ol>
      )}
      <button type="button" className="news-btn-primary" onClick={handleMake}>
        이 활동 학습지 만들기
      </button>
      {date && (
        <NewsShareButton
          target="idea"
          title={idea.title}
          text={`${idea.minutes ? `${idea.minutes}분 ` : ''}수업 아이디어 · 왓퀴즈 아침 교육 뉴스`}
          path={`/news/${date}#idea`}
          buttonTitle="아이디어 보기"
          subtle
        >
          동료 선생님께 보내기
        </NewsShareButton>
      )}
    </section>
  );
};

export default NewsClassroomIdea;
